module.exports = __webpack_public_path__ + "img/alert-red.f983c2cd.svg";